import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { SECTORS } from '../../../utils/sectors';

export default function CompleteStep({ resetPath, activities }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const firstName = user?.name?.split(' ')[0] || 'there';

  const priorityTop3 = resetPath?.priority_sectors?.slice(0, 3) || [];

  return (
    <div className="max-w-lg mx-auto px-4 py-8 text-center">
      <div className="text-5xl mb-4">🎉</div>
      <h1 className="font-serif text-2xl font-bold text-reset-brown mb-3">
        You&apos;re set up, {firstName}.
      </h1>
      <p className="text-gray-600 mb-6 leading-relaxed">
        Your reset path is built. The system is watching. From here, it works quietly in the
        background — and reaches out when it notices something shifting.
      </p>

      {/* Summary */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5 text-left mb-8 space-y-4">
        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Your top priorities</p>
          <div className="flex flex-wrap gap-2">
            {priorityTop3.map(key => {
              const sector = SECTORS.find(s => s.key === key);
              return sector ? (
                <span key={key} className={`flex items-center gap-1 text-sm font-medium px-3 py-1 rounded-full ${sector.badgeClass}`}>
                  {sector.emoji} {sector.label}
                </span>
              ) : null;
            })}
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">
            Activities you&apos;re committed to
          </p>
          <p className="text-2xl font-bold text-reset-terracotta">{activities?.length || 0}</p>
        </div>

        <div className="bg-reset-cream rounded-xl p-3">
          <p className="text-xs text-gray-500 leading-relaxed">
            <span className="font-semibold text-reset-brown">What happens next: </span>
            The system will send your first morning check-in tomorrow at your chosen time.
            Connect your calendar and wearable in settings to unlock the full picture.
          </p>
        </div>
      </div>

      <button
        onClick={() => navigate('/dashboard')}
        className="w-full bg-reset-terracotta text-white py-3 rounded-xl font-semibold text-sm hover:opacity-90 transition"
      >
        Go to my dashboard →
      </button>
    </div>
  );
}
